<template>
  <div>
    <PageAllow controller="Shops" action="shopStockOrdersInDetails" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("StockOrderOUT.ObjectName")]) }}
              <v-chip
                v-if="stock_outs.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <span>
                <v-chip
                  v-if="stock_outs.type == 13 && stock_outs.actions.out_re_push"
                  small
                  label
                  class="ms-4 mt-1"
                  color="danger"
                  text-color="white"
                >
                  {{ $t("StockOrderOUT.status.pushError") }}
                </v-chip>
                <v-chip
                  v-else
                  small
                  label
                  class="ms-4 mt-1"
                  :color="stock_outs.status | stockOrderOUTStatusColor"
                  :text-color="stock_outs.status | stockOrderOUTStatusTextColor"
                >
                  {{ stock_outs.status | stockOrderOUTStatusText }}
                </v-chip>
              </span>
              <v-spacer />
              <StockOrderOUTActions
                :stock_out="stock_outs"
                :shop_id="this.$route.query.shop_id"
                showExport
              />
            </v-card-title>
          </v-expansion-panel-header>

          <ValidationObserver ref="observer">
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <!-- 出库单编号 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.stock_out_code") }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.stock_order_code }}
                  </v-card>
                </v-col>
                <!-- 仓库名称 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.stock_name") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ $t("StockOrderOUT.Fields.default_stock_name") }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 创建时间 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.created_time") }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.created | formatTime }}
                  </v-card>
                </v-col>

                <!-- 出库类型 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.stock_out_type") }}{{ $t("Global.colon") }}
                    </span>
                    <span>{{ stock_outs.out_type_str }}</span>
                  </v-card>
                </v-col>
                <!-- 出库类型 -->
                <v-col cols="12" md="4" v-if="stock_outs && stock_outs.type == 11">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.broken_type") }}{{ $t("Global.colon") }}
                    </span>
                    <span>{{ stock_outs.broken_type | stockOrderOUTBrokenTypeText}}</span>
                  </v-card>
                </v-col>
                <!-- 负责人 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.creater") }}{{ $t("Global.colon") }}
                    </span>
                    {{ stock_outs.operater_name }}
                  </v-card>
                </v-col>
                <!-- 实际发生时间 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.actual_time") }}{{ $t("Global.colon") }}
                    </span>
                    <span>{{ stock_outs.actual_date | formatTime }}</span>
                  </v-card>
                </v-col>
                <!-- 出库时间 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.finish_time") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{
                        stock_outs.type == 3
                          ? stock_outs.actual_finish_time
                          : stock_outs.finish_time | formatTime
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 调入门店名称 -->
                <v-col cols="12" md="4" v-if="stock_outs.type == 2">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.in_shop")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_outs.requisition_shop.shop_name }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 备注 -->
                <v-col
                  cols="12"
                  :md=" stock_outs.type == 2 ? 8 : 12"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockOrderOUT.Fields.attachment") }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ stock_outs.memo }}
                    </span>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </ValidationObserver>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab @click.stop="tab = 0;">
                {{ $t("ActivityFields.activities") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="stock_out_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-sheet>

    <div class="px-4 pb-4">
      <v-data-table
        v-if="stock_outs.type != 13"
        :headers="detailsHeaders"
        :items="stockOutDetails"
        :search="filter"
        multi-sort
        class="elevation-2 px-4 mt-4"
        disable-pagination
        hide-default-footer
        :no-data-text="$t('StockOrderIN.DetailNoData')"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("StockOrderOUT.ObjectName")]) }}
            </v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <span class="caption secondary--text pt-2">
              {{
                $t(
                  "$vuetify.dataFooter.pageText",
                  stockOutDetails.length
                    ? [1, stockOutDetails.length, stockOutDetails.length]
                    : [0, 0, 0]
                )
              }}
            </span>
            <v-spacer />
            <v-row no-gutters class="me-n3">
              <v-spacer />
              <v-col cols="12" sm="9" md="8">
                <v-text-field
                  v-model="filter"
                  clearable
                  hide-details
                  :label="$t('Search.filter')"
                />
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:header.actions="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.Description="{ item }">
          <a
            class="text-no-wrap"
            :class="item.error_flg ? 'red--text' : ''"
            @click.stop="dialogMaterialID = item.material_id"
          >
            {{ item.Description }}
          </a>
        </template>
        <template v-slot:item.unit="{ item }">
          <span> {{ item.unit }} </span>
        </template>
        <template v-slot:item.current_count="{ item }">
          <span>
            <span class="text-no-wrap">
              {{ item.current_count }}
            </span>
            <span class="text-no-wrap">
              {{ item.unit }}
            </span>
          </span>
        </template>
        <template v-slot:item.confirm_num="{ item }">
          <span>
            {{ item.confirm_num }}
          </span>
        </template>
        <template v-slot:item.out_num="{ item }">
          <span>
            {{ item.out_num ? item.out_num : "" }}
          </span>
        </template>
        <template v-slot:item.price="{ item }">
          <span>
            {{ $t("Global.money") }}
            {{ item.price | formatMoney }}
          </span>
        </template>
        <template v-slot:item.total="{ item }">
          <span>
            {{ $t("Global.money") }}
            {{ item.total | formatMoney }}
          </span>
        </template>
        <template v-slot:item.memo="{ item }">
          <span>
            {{ item.memo }}
          </span>
        </template>
      </v-data-table>
      <!-- 退货出库table -->
<!--      <ValidationObserver ref="observer">-->
        <v-data-table
          v-else
          :headers="returnHeaders"
          :items="stockOutDetails"
          :search="filter"
          multi-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('StockOrderIN.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("StockOrderOUT.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
            <span class="caption secondary--text pt-2">
              {{
                $t(
                  "$vuetify.dataFooter.pageText",
                  stockOutDetails.length
                    ? [1, stockOutDetails.length, stockOutDetails.length]
                    : [0, 0, 0]
                )
              }}
            </span>
              <v-spacer />
              <v-row no-gutters class="me-n3">
                <v-spacer />
                <v-col cols="12" sm="9" md="8">
                  <v-text-field
                    v-model="filter"
                    clearable
                    hide-details
                    :label="$t('Search.filter')"
                  />
                </v-col>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.Description="{ item }">
            <a
              class="text-no-wrap"
              :class="item.error_flg ? 'red--text' : ''"
              @click.stop="dialogMaterialID = item.material_id"
            >
              {{ item.Description }}
            </a>
          </template>
          <template v-slot:item.stock_batch_code="{ item }">
            <span>
              {{ item.stock_detail.stock_batch_code }}
            </span>
          </template>
          <template v-slot:item.return_num="{ item }">
            <span>
            {{ item.return_num }}
          </span>
          </template>
          <template v-slot:item.price="{ item }">
            <span>
            {{ $t("Global.money") }}
            {{ item.price | formatMoney }}
          </span>
          </template>
          <template v-slot:item.total="{ item }">
          <span>
            {{ $t("Global.money") }}
            {{ item.total | formatMoney }}
          </span>
          </template>
          <template v-slot:item.memo="{ item }">
            <span>
            {{ item.memo }}
          </span>
          </template>
        </v-data-table>
<!--      </ValidationObserver>-->
    </div>

  </div>
</template>
<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockOrderOUTActions from "./plugins/Actions";
import i18n from "@/i18n";
// import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ValidationObserver } from "vee-validate";
// import NumberInput from "@/components/plugins/NumberInput";
import Shops from "@/api/shops";
import { mapState } from "vuex";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockOrderOUTActions,
    ValidationObserver,
    // ValidationProvider,
    // NumberInput,
  },
  data: () => ({
    productionStockOUTFlg: false,
    tab: null,
    mode: "",
    stock_outs: {},
    stock_out_activities: [],
    panels: [0],
    filter: "",
    stock_out_details: [],
    addMaterial: null,
    addMaterials: [],
    returnMaterials: [],
    Dialog: false,
    ReturnDialog: false,
    shopSelected: null,
    stockPreview: [],
  }),
  mounted() {
    this.getStockOutsFromAPI()
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopPsi"),
          disabled: false,
          href: "/shop-psi",
        },
        {
          text: i18n.t("Nav.shopStockOrdersOut"),
          disabled: false,
          href: "/shop-stock-orders-out",
        },
        {
          text: i18n.t("Nav.stockOutDetail"),
          disabled: true,
        },
      ];
      items.push({
        text: this.stock_outs && this.stock_outs.stock_order_code ? this.stock_outs.stock_order_code : "",
        disabled: false,
        accent: true,
      });
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("StockOrderOUT.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.material_name"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
      ];
      if (this.stock_outs.status == 2) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.current_stock_quantity"),
          align: "center",
          value: "current_count",
        });
      }
      headers.push({
        text: i18n.t("StockOrderOUT.DetailFields.stock_out_order_num"),
        align: "end",
        value: "confirm_num",
      });
      headers.push({
        text: i18n.t("StockOrderOUT.DetailFields.stock_out_practical_num"),
        align: "end",
        value: "out_num",
      });
      if (this.stock_outs.status == 3) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.price"),
          align: "end",
          sortable: false,
          value: "price",
        });
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.count_num"),
          align: "end",
          sortable: false,
          value: "total",
        });
      }
      headers.push({
        text: i18n.t("StockOrderOUT.DetailFields.memo"),
        align: "end",
        width: "130px",
        sortable: false,
        value: "memo",
      });

      return headers;
    },
    returnHeaders() {
      var headers = [
        {
          text: i18n.t("StockOrderOUT.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.material_name"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("stockDetail.Fields.stock_batch_code"),
          align: "start",
          value: "stock_batch_code",
        },

      ];
      if (this.settings && this.settings.product_date_setting == 1) {
        headers.push(
          {
            text: i18n.t("stockDetail.Fields.production_date"),
            align: "start",
            value: "production_date",
          },
          {
            text: i18n.t("stockDetail.Fields.expired_date"),
            align: "start",
            value: "expired_date",
          });
      }
      headers.push(
        {
          text: i18n.t("StockOrderOUT.DetailFields.stock_out_order_num"),
          align: "center",
          width: "120px",
          value: "order_num",
        },
        {
          text: i18n.t("StockOrderOUT.DetailFields.stock_out_confirm_num"),
          align: "center",
          width: "120px",
          value: "confirm_num",
        }
      );
      if (this.stock_outs.status == 3) {
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.price"),
          align: "end",
          sortable: false,
          value: "price",
        });
        headers.push({
          text: i18n.t("StockOrderOUT.DetailFields.total"),
          align: "end",
          sortable: false,
          value: "total",
        });
      }
      headers.push(
        {
          text: i18n.t("StockOrderOUT.DetailFields.memo"),
          align: "center",
          width: "130px",
          sortable: false,
          value: "memo",
        }
      )
      return headers;
    },
    stockOutDetails() {
      return this.stock_out_details.map((detail) => {
        detail.Description = i18n.t(
          "Material.materialNameWithCodeAndStandard",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountUser", "settings"]),
  },
  methods: {
    getStockOutsFromAPI() {
      Shops.shopStockOrdersOutDetails({
        stock_order_id: this.$route.params.id,
        shop_id: this.$route.query.shop_id,
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_outs = response.data.stock_out;
            this.stock_out_activities = response.data.order_activities;
            if (this.stock_outs.type == 13) {
              Shops.returnOrderView({
                stock_order_id: this.$route.params.id,
                shop_id: this.$route.query.shop_id,
                order_activity: 1,
              }).then((response) => {
                this.stock_outs = response.data.stock_out;
                this.stock_out_details = this.stock_outs && this.stock_outs.stock_order_details ? this.stock_outs.stock_order_details : [];
              })
            }else {
              this.stock_out_details = this.stock_outs && this.stock_outs.stock_order_details ? this.stock_outs.stock_order_details : [];
              if (this.mode == "out") {
                this.stock_out_details.forEach((detail) => {
                  detail.out_num = detail.confirm_num;
                });
              }
            }
          }
        }.bind(this)
      );
    },
    exportDetail() {
      // StockOuts.detailExport(this.stock_outs.id);
    },
  },
  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/shop-stock-orders-out/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getStockOutsFromAPI();
        }
      },
    },
  },
};
</script>
